import React, { Component } from "react";
import { connect } from "react-redux";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "state/actions/UiActions";
import { Utils } from "utils/Utils";
import { Modal } from "components/modal/Modal";

import Styles from "components/pagamento/PaymentHistory.module.scss";
import { GetEditionDateName } from "core/utils/EditionUtils";
import { BillingStatus } from "core/utils/SubscriberUtils";
import { ToCurrency } from "core/utils/Utils";

class PaymentHistory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      susbcriptionInfo: props.subscriptionInfo,
      paymentHistory: null,
      tempPaymentHistory: null,
      currentTransaction: null, 
      editionsModalVisible: false,

      pending: false

    }
  }

  componentDidMount() {
    if (this.props.person.personStatus !== 14) {
      this.getPaymentHistory();
    }  
  }

  getPaymentHistory = () => {
    const {
      Authorization
    } = this.props.token;

    let subscriberId = this.props.subscriptionInfo.id;
   
    this.setState({
      pending: true
    });

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.paymentHistoryBySubscriberId,
      //GlamboxEndpoints.Subscriber.paymentHistory,
      null, // ORIGINALMENTE RECEBIA SUBSCRIBER ID, PODE SER NECESSÁRIO
      "GET",
      {
        Authorization
      },
      {
        subscriberId
      },
      (response) => {
        const {
          result,
          statusCode
        } = response;
        
        if (statusCode === 200) {
          this.updateHistoryState(result);
        } else {
          this.setState({
            pending: false
          });
        }
      }
    );
  }

  updateHistoryState = (result) => {

    let resultHistory = result.history;
    let history = [];

    for (let paymentId in resultHistory) {
      var obj = resultHistory[paymentId];
      var aux = {
        key: obj.key,
        billings: [],
        boletoUrl:null
      };

      for (let i = 0; i < obj.billings.length; i++) {
        aux.billings.push({
          amount: obj.billings[i].amount,
          date: obj.billings[i].dateCreated,
          editionId: obj.billings[i].editionId,
          editionName: GetEditionDateName(obj.billings[i].editionId),
          status: obj.billings[i].subscriberBillingStatus,
          billingStatus: BillingStatus(obj.billings[i].subscriberBillingStatus)          
        });

        aux.boletoUrl = obj.billings[i].boletoUrl
      }

      history.push(aux);

    }
    const tempPaymentHistory = this.paymentHistoryToArray(history);

    history.sort((a, b) => {
      return (b.key.dateCreated - a.key.dateCreated);
    });

    tempPaymentHistory.sort((a, b) => {
      return (b.key.dateCreated - a.key.dateCreated);
    });

    this.setState({ paymentHistory: history, tempPaymentHistory: tempPaymentHistory , pending:false });

  }

  renderPaymentHistoryTransactions = () => {

    const { tempPaymentHistory } = this.state;

    if (!tempPaymentHistory) return null;

    return tempPaymentHistory.map((item, key) => {
      let dateConverted = this.dateConvert(item.key.dateCreated);      
      //let editionName = item.billings.length === 0 ? null : item.billings[0].editionName;
      let editionName = (item.billings.length === 0)
        ? null 
        : GetEditionDateName(item.billings[0].editionId);
      return (
        <tr key={key}>
          <td><strong>Transação:</strong> <span>#{item.key.transactionId}</span></td>
          <td><strong>Status:</strong><span>{item.key.authorizationMessage}</span></td>
          <td><strong>Valor:</strong><span>{ToCurrency(item.key.amount)}</span></td>
          <td><strong>Data:</strong><span>{dateConverted}</span></td>
          <td><strong>Edição:</strong>{item.billings.length > 1 ? 
             <button onClick={this.setCurrentTransaction(key)} className ={"btn btn-sm btn-outline-light-pink"}>Ver edições</button> 
             : <span>{editionName}</span> }</td>
            <td>  {item.boletoUrl &&  
                  <a className = {"btn btn-sm btn-outline-light-pink"} href={item.boletoUrl} target={"_blank"}>
                    Ver boleto
                  </a>} 
            </td>
        </tr>
      );
    });
  }

  paymentHistoryToArray = (paymentHistory) => {
    if (!paymentHistory) return null;

    let paymentKeys = Object.keys(paymentHistory).map((item, key) => {
      return paymentHistory[item];
    });
    return paymentKeys;
  }

  dateConvert = (dateToConvert) => {
    let date = new Date(dateToConvert);
    return date.toLocaleDateString();
  }

  setCurrentTransaction = (key) => {
    return (event) => {
      event.preventDefault();

      this.setState(
        { 
          currentTransaction: key
        },
        () => {
          this.setState({ 
            editionsModalVisible: true 
          });
          this.forceUpdate();
        }
      );
    }
  }

  closeEditionsModal=()=>{
    this.setState({
      editionsModalVisible: false,
      currentTransaction: null

    })
  }

  renderEditions = () => {
    let { currentTransaction } = this.state;

    if (!currentTransaction && typeof currentTransaction !== "number") return null;

    let { billings } = this.state.tempPaymentHistory[currentTransaction];

    let editions = billings.map((item, key) => {
      return (
        <tr key={key}>
          <td>{(item.editionName)}</td>
          <td>{ToCurrency(item.amount)}</td>
          <td>{(item.billingStatus)}</td>
        </tr>
      )
    });

    return (
      <div id={Styles["paymentList"]}>
      <table cellSpacing="0" cellPadding="0" border="0">
        <thead>
          <th>Edição</th>
          <th>Valor</th>
          <th>Status</th>
        </thead>
        <tbody>
          {editions}
        </tbody>        
      </table>
      </div>
    )
  }

  showValidationMessage() {
    const validationMessage = this.state.validationMessage;
    return (<h3>{validationMessage}</h3>);
  }

  render() {

    if(this.state.pending){
      return(
        <div>
          CARREGANDO...
        </div>
      );
    }

    if (this.state.paymentHistory === null || this.state.paymentHistory.length === 0) {
      return (
        <div style={{ width: "100%" }}>
          <h3 className={"p-2 p-lg-4 mb-0"}>Pagamentos</h3>         
          <div className={"level-2 gp_alert_pis"} style={{ margin: "0 20px 20px 20px" }}>
            <div className={ "icon" }>
              <svg width="36" height="36" viewBox="0 0 36 36">
                <path d="M6.4,36V32.836a3.17,3.17,0,0,1,2.11-2.983V18a9.492,9.492,0,0,1,18.985,0V29.853a3.17,3.17,0,0,1,2.11,2.983V36Zm2.11-3.164V33.89H27.492V32.836a1.056,1.056,0,0,0-1.055-1.055H9.563A1.056,1.056,0,0,0,8.508,32.836ZM10.617,18V29.672H25.383V18a7.383,7.383,0,0,0-14.765,0Zm6.328,7.383v-2.11h2.11v2.11Zm0-4.218V14.836h2.11v6.329Zm14.765-2.11v-2.11H36v2.11ZM0,19.055v-2.11H4.289v2.11ZM4.576,6.068,6.068,4.576,9.05,7.559,7.559,9.051ZM26.95,7.559l2.983-2.984,1.491,1.492L28.441,9.05Zm-10-3.27V0h2.11V4.289Z" fill="#933ec5"/>
              </svg>
            </div>
            Ainda não foram detectados pagamentos para esta assinatura
          </div>   
        </div>      
      )
    }

    return (
      <div id={Styles["paymentList"]}>
        <h3 className={"p-2 p-lg-4 mb-0"}>Pagamentos</h3>
        <table cellSpacing="0" cellPadding="0" border="0">
          <thead>
            <tr>
              <th>Transações</th>
              <th>Status</th>
              <th>Valor</th>
              <th>Data</th>
              <th>Edição</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.renderPaymentHistoryTransactions()}
          </tbody>
        </table>
        <Modal visible={this.state.editionsModalVisible} onCloseModal = {this.closeEditionsModal}>
          {this.renderEditions()}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.token.data,
    person: state.person.data
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message))
    }
    , errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message))
    }
  }
}

PaymentHistory = connect(mapStateToProps, mapDispatchToProps)(PaymentHistory);

export { PaymentHistory };